import React from "react";
import { Divider, Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickOrderDetailCard from "@/features/pathpick/features/order-history/features/detail/components/PathPickOrderDetailCard";
import PathPickOrderDetailProductRow from "@/features/pathpick/features/order-history/features/detail/components/products-section/PathPickOrderDetailProductRow";
import { ORDER_DETAIL_KEY } from "@/features/pathpick/features/order-history/features/detail/constants";
import { PathPickOrder } from "@/features/pathpick/features/order-history/types/response";

interface Props {
  // 확정/취소 표기는 상품 단위로 정하되 주문 단위 폴백이 필요해, 행이 주문을 통째로 받는다.
  order: PathPickOrder;
}

function PathPickOrderDetailProducts({ order }: Props) {
  const { t } = useI18nHelper();
  const items = order.items;

  return (
    <PathPickOrderDetailCard
      title={t(`${ORDER_DETAIL_KEY}products_title`)}
      gap={"12px"}
      headerRight={
        <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
          {t(`${ORDER_DETAIL_KEY}product_count`, { count: items.length })}
        </Text>
      }
    >
      <Flex flexDirection={"column"} gap={"12px"}>
        {items.map((item, index) => (
          <React.Fragment key={item.id}>
            {index > 0 && <Divider borderColor={"#EFEFED"} />}
            <PathPickOrderDetailProductRow item={item} order={order} />
          </React.Fragment>
        ))}
      </Flex>
    </PathPickOrderDetailCard>
  );
}

export default PathPickOrderDetailProducts;
